// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"243":"styling","345":"portfolio","353":"contact"}[chunkId] || chunkId) + "." + {"243":"3ff558c5","345":"c6f44a2d","353":"c8fb4a81","366":"bcfcdecc"}[chunkId] + ".js";
};